module.exports = __webpack_public_path__ + "static/media/starterCollection.f1dc73cb.png";